<style lang="less" scoped src="@/assets/less/manage-space/base.less"></style>

<template>
    <div>
        <div class="pl-sm-4 mt-4">
            <div class="bg-white round-unify p-3">
                <div>
                    <div class="d-flex w-100 justify-content-between">
                        <h2>{{ $t('labels.backfill') }}</h2>
                        <div>
                            <b-button variant="primary" class="ml-3" @click="backfill">{{
                                $t('labels.backfill')
                            }}</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EventBus from '@/eventBus';

export default {
    name: 'CustomerSettings',
    data() {
        return {
            space: null,
        };
    },
    mounted() {},
    methods: {
        backfill() {
            const data = {
                OverrideStartNumber: false,
            };
            axios({
                method: 'POST',
                url: '/admin/customer/backfill',
                data,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    const msg = {
                        Message: this.$t('messages.customerNumbersBackfilled'),
                        Details: '',
                    };
                    EventBus.$emit('INFO', msg);
                })
                .catch((error) => {
                    console.log(error);
                    const msg = {
                        Message: this.$t('messages.customerNumbersBackfillFailed'),
                        Details: '',
                    };
                    EventBus.$emit('ERROR', msg);
                })
                .finally(() => {});
        },
    },
};
</script>
